import { DATA_BUILTIN_DIMENSION_SPECS, DIMENSION_CATEGORY_ID } from 'shared-types';
import { registerSketchObjectType } from '../registry';
import { buildDataSketchObjectType } from '../custom/customSketchObjectType';
import { t } from '../../translation/markers';

/** Library labels of the built-in dimensions (extraction markers for the shared spec names). */
const LABELS: Readonly<Record<string, string>> = {
  dimension: t('Dimension'),
};

/** Extraction markers for the built-in dimension's param labels and options (the panel translates by source string). */
export const DIMENSION_PARAM_TEXT = [t('ends'), t('ticks'), t('arrows'), t('open arrows'), t('dots'), t('straight ends'), t('none'), t('line'), t('solid'), t('dashed'), t('extension lines')];

/**
 * The built-in dimension annotation (pure data, shared-types
 * builtins/dimensions.ts): the dimension tool's library, armed first. Its
 * look (ends, line style, extension lines) is a param of the placed one.
 */
for (const { id, label, spec } of DATA_BUILTIN_DIMENSION_SPECS) {
  registerSketchObjectType(buildDataSketchObjectType(id, LABELS[id] ?? label, DIMENSION_CATEGORY_ID, spec));
}
